import {colors} from '../../styles';
import {HeatCycleIndex} from '../ble2/v2/PeakDevice/UnitCycleAccess';
import {HeatProfile, MoodLight, isColorLight} from '../types';

export const toHeatCycle = (
  heatProfile: HeatProfile,
  getMoodLight: (id: string) => MoodLight | undefined,
) => {
  const moodLight = !isColorLight(heatProfile.light)
    ? getMoodLight(heatProfile.light.id)
    : undefined;

  return {
    ...heatProfile,
    order: heatProfile.order as HeatCycleIndex,
    light: isColorLight(heatProfile.light)
      ? heatProfile.light
      : moodLight
        ? moodLight
        : // TODO: Consider using update functions as a patch instead of put: this here is an issue
          {color: colors.defaultColor},
  };
};
